/**
 * The nav mirrors `allNavItems` in the Remix reference's TopBar, in the same
 * Paths point at this app's equivalent routes (see src/nav.json + src/Pages).
 */
export const NAV_ITEMS = [
  { path: 'ai-home', name: 'AI Home' },
  // { path: 'workforce', name: 'Workforce' },
  { path: 'campaign-manager', name: 'Campaigns' },
  { path: 'leads-module', name: 'Contacts' },
  { path: 'email-accounts', name: 'Accounts' },
  { path: 'unibox', name: 'Unibox' },
  { path: 'tasks', name: 'Tasks' },
  { path: 'analytics', name: 'Analytics' },
];
